import ModalVideo from "../modals/ModalVideo";

const ImportModals = () => {
    return (
        <div id={'base-box-all-modals'}>
        	<ModalVideo />
        </div>
    );
}

export default ImportModals;
